import { handleApi } from '../common';

const API_ENDPOINTS = {
	getScripDetail: '/api/equity/api/eqm/wave/market/get_quote_details',
	getMasterScripData: (nToken, marketSegmentId, isGuestApiAllowed) =>
		`/api/equity/api/eqm/scrip/master/get_llfc_data/${nToken}/${marketSegmentId}?guest=${isGuestApiAllowed}`,
	getMasterScripDataList: (isGuestApiAllowed) =>
		`/api/equity/api/eqm/scrip/master/get_llfc_data?guest=${isGuestApiAllowed}`,
};

export const getScripDetail = async (Api, payload = {}, token = '') => {
	const response = await Api.post(
		API_ENDPOINTS.getScripDetail,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};

export const fetch_master_scrip_data = async (
	Api,
	token = '',
	marketSegmentId,
	isGuestApiAllowed = false,
) => {
	const response = await Api.get(
		API_ENDPOINTS.getMasterScripData(
			token,
			marketSegmentId,
			isGuestApiAllowed,
		),
	);
	const result = handleApi(response);
	return result;
};

export const fetch_master_scrip_data_list = async (
	Api,
	payload = [],
	isGuestApiAllowed = false,
) => {
	const body = {
		tokens: payload,
	};
	const response = await Api.post(
		API_ENDPOINTS.getMasterScripDataList(isGuestApiAllowed),
		body,
	);
	const result = handleApi(response);
	return result;
};
